import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const alignClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-3xl ${alignClass}`} data-id="element-283" data-mp="3k29j646802y8">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${tone === 'dark' ? 'text-gold' : 'text-brand'}`} data-id="element-284" data-mp="bloirbrnmi6q">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-heading text-[1.9rem] font-semibold leading-[1.12] sm:text-4xl lg:text-[2.75rem] ${tone === 'dark' ? 'text-white' : 'text-ink'}`} data-id="element-285" data-mp="1v3og0j0jztm">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-[1.05rem] leading-relaxed sm:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-ink/70'}`} data-id="element-286" data-mp="uhwr4ofyr969">{intro}</p>}
    </div>;
}